/**
 * A citation source-chip label is meaningful only when it isn't empty or a bare
 * `()` placeholder (a backend citation bug where a source has no real label).
 * Guards every source chip so the UI never shows an empty / `()` citation.
 */
export function isMeaningfulSourceLabel(label: string | null | undefined): label is string {
  const trimmed = label?.trim()
  return !!trimmed && trimmed !== '()'
}
